import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
interface ProcessingScreenProps {
  childName: string;
  onDone: () => void;
}
export function ProcessingScreen({
  childName,
  onDone
}: ProcessingScreenProps) {
  const messages = [`Preparando el perfil de ${childName}…`, 'Organizando su información…', 'Todo listo 💜'];
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const timers = [setTimeout(() => setIndex(1), 950), setTimeout(() => setIndex(2), 1900), setTimeout(onDone, 2800)];
    return () => timers.forEach(clearTimeout);
  }, [onDone]);
  return <section className="mx-auto flex w-full max-w-md flex-1 flex-col items-center justify-center px-8 text-center" role="status" aria-live="polite" data-id="element-85" data-mp="puvy07hm64je">
      <div className="relative grid h-28 w-28 place-items-center" data-id="element-86" data-mp="3tbvvyfhswytf">
        <motion.span className="absolute h-28 w-28 rounded-full bg-lavender-200/60" animate={{
        scale: [1, 1.18, 1],
        opacity: [0.5, 0.15, 0.5]
      }} transition={{
        duration: 2.2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-87" data-mp="26clffrj75li" />
        <motion.div className="h-14 w-14 rounded-full border-[3px] border-lavender-200 border-t-violet-500" animate={{
        rotate: 360
      }} transition={{
        duration: 1.1,
        repeat: Infinity,
        ease: 'linear'
      }} data-id="element-88" data-mp="3mkwoxr8afdnb" />
      </div>

      <AnimatePresence mode="wait" data-id="element-89" data-mp="38t9hqwct4kpr">
        <motion.p key={index} initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -10
      }} transition={{
        duration: 0.35
      }} className="mt-7 font-display text-lg text-ink" data-id="element-90" data-mp="38ub5a0b0ezod">
          {messages[index]}
        </motion.p>
      </AnimatePresence>
    </section>;
}